import type { DefaultCity } from './types';

/** 无本地/接口城市数据时的兜底城市（合肥市） */
export const DEFAULT_CITY: DefaultCity = {
    id: 1,
    name: '合肥市',
    mapId: 1,
    areaId: 3401,
    latlon: [117.227267, 31.820567],
};

/** 地图 VIP 版本：0 基础版 / 1 标准版 / 2 全能版 */
export const MAP_VIP_VERSION = {
    BASIC: 0,
    STANDARD: 1,
    PREMIUM: 2,
} as const;

/** 地图 VIP 状态：0 在期 / 1 过期 */
export const MAP_VIP_STATUS = {
    ACTIVE: '0',
    EXPIRED: '1',
} as const;
